import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { createForwardedInvoicePreview } from './createForwardedInvoicePreview';
import {
  type CreateForwardedInvoicePreviewPayload,
  type ForwardedInvoicePreviewResponse,
} from './types';

/**
 * A custom hook to create a preview of a reprocessing invoice with a given process ID that the user wants to forward.
 * Uses the `useMutation` hook from `@tanstack/react-query` internally.
 * @param options - Optional configuration for the mutation.
 * @returns The mutation result.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/create_invoice_preview_invoice_process__process_id__invoice_preview_post
 */
export const useMutationCreateForwardedInvoicePreview = (
  options?: UseMutationOptions<
    ForwardedInvoicePreviewResponse,
    unknown,
    CreateForwardedInvoicePreviewPayload
  >,
) => {
  return useMutation({
    mutationFn: createForwardedInvoicePreview,
    onError(_error) {
      return; // prevent error from bubbling up further unless overridden via mutation options
    },
    ...options,
  });
};
